import React, { useState, useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { Swiper, SwiperSlide } from 'swiper/react';
import RightToLeft from "../../../../components/transitions/right-to-left";
import { fetchBeautyLookItem } from "../../../../../api";
import { Iconfont } from "../../../../components/icon/iconfont";
import SwiperProduct from "../../module/swiper-product/swiper-product.jsx"
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const BeautyLooksItem = props => {
    useStyles(classes);
    const { beautyLook, beautyLooks, onClose } = props;
    const [beautyItem, setBeautyItem] = useState(null);

    useEffect(async () => {
        if(beautyLook?.id){
            setBeautyItem(null);
            let response = await fetchBeautyLookItem(beautyLook?.id).then((data) => data.result).catch((e) => {
                console.log("e", e.result)
                return null;
            });
            setBeautyItem(response);
        }
        
    }, [beautyLook?.id]);

    return <div className={classes.BeautyLooksItem}>
        <div className={classes.BeautyLookHd}>
            <span className={classes.Font}><FormattedMessage id="get_the_look" defaultMessage="Get the look" /></span>
            <Iconfont className={`${classes.Icon}`} onClick={onClose}>&#xe693;</Iconfont>
        </div>

        {
            beautyItem ? (<React.Fragment>
                <div className={classes.BeautyLookBd}>
                    <div className={classes.Image} style={{ backgroundImage: `url(${beautyItem?.image})` }}></div>
                    <div className={classes.Container}>
                        <p className={classes.Title}><FormattedMessage id="get_the_look" defaultMessage="Get the look" /></p>
                        <div className={classes.BeautyContainer}>
                            {
                                beautyItem?.products?.map((item, index) => <SwiperProduct product={item} position={index + 1} isBeautyLook={true} />)
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>) :
                (
                    <div className={classes.Loading}>
                        <FormattedMessage id="loading" defaultMessage="Loading" />
                    </div>
                )
        }

        {
            beautyLooks?.length > 1 && beautyLook && <div className={classes.BeautyLookFd}>
                <div className={classes.Container}>
                    <div className={beautyLooks?.length > 1 && beautyLooks[0]?.id === beautyLook.id ? classes.Disabled : ""} onClick={() => props?.onBeautyLook(false)}>
                        <Iconfont>&#xe693;</Iconfont>
                        <span><FormattedMessage id="previous" defaultMessage="Previous" /></span>
                    </div>
                    <div className={beautyLooks?.length > 1 && beautyLooks[beautyLooks.length - 1]?.id === beautyLook.id ? classes.Disabled : ""} onClick={() => props?.onBeautyLook(true)}>
                        <span><FormattedMessage id="next" defaultMessage="Next" /></span>
                        <Iconfont>&#xe694;</Iconfont>
                    </div>
                </div>
            </div>
        }
    </div>
}

const BeautyLooksModal = props => {
    const { beautyLook } = props;

    return <React.Fragment>
        <RightToLeft in={!!beautyLook?.id}>
            <BeautyLooksItem {...props} />
        </RightToLeft>
    </React.Fragment>
}

const BeautyLooksSwiper = props => {
    useStyles(classes);
    const { beautyLooks } = props;
    const [beautyLook, setBeautyLook] = useState(null);

    const onBeautyLook = (flag) => {
        let index = beautyLook?.index;
        if (flag) {
            ++index;
        } else {
            --index;
        }
        setBeautyLook({ id: beautyLooks[index]?.id, index: index });
    }

    const beautyLookShow = (data) =>{
        setBeautyLook(data);
        document.body.style.overflow = 'hidden';
    }

    const beautyLookHide = () =>{
        setBeautyLook(null);
        document.body.style.overflow = 'auto';
    }

    return <React.Fragment>
        <Swiper
            spaceBetween={10}
            slidesPerView='auto'
            onSlideChange={(swiper) => console.log()}
            onSwiper={(swiper) => console.log()}
        >
            {
                beautyLooks?.map((item, index) => <SwiperSlide key={index} className={classes.Item}>
                    <span
                        style={{ backgroundImage: `url(${item.image})` }}
                        onClick={() => beautyLookShow({ id: item.id, index: index })}
                    >
                    </span>
                </SwiperSlide>)
            }
        </Swiper>
        <BeautyLooksModal beautyLooks={beautyLooks} beautyLook={beautyLook} onBeautyLook={onBeautyLook} onClose={beautyLookHide} />
    </React.Fragment>


}

const ProductBeautyLooks = props => {
    useStyles(classes);
    const { beautyLooks } = props;
    const global = useSelector((state) => state.global);

    return (
        <div className={`${classes.ProductBeautyLooksContainer} ${classes.GolbalBorderTop}`}>
            <div className={classes.Hd}>
                @{global?.config?.name} <FormattedMessage id="beauty" defaultMessage="Beauty" />
            </div>

            <div className={classes.Bd}>
                <BeautyLooksSwiper beautyLooks={beautyLooks} />
            </div>
        </div>
    )
}

export default ProductBeautyLooks;